export default {
  "badge-status": "_badge-status_10yerk",
  "error": "_error_10yerk",
  "inactive": "_inactive_10yerk",
  "in-progress": "_in-progress_10yerk",
  "validated": "_validated_10yerk",
  "waiting": "_waiting_10yerk"
};